const nav = require('../utils/nav').Utils;
const auth = require('../utils/auth').Auth;

exports.PaymentService = {
    subscribe: function(token, statusID, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback();
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        let body = {
            stripeToken: token,
            statusID: statusID
        };
        xmlhttp.open('POST', auth.getFullUrl('subscribe'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send(JSON.stringify(body));
    },

    update: function(token, statusID, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback();
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        let body = {
            stripeToken: token,
            statusID: statusID
        };
        xmlhttp.open('POST', auth.getFullUrl('payment'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send(JSON.stringify(body));
    }
}